<section [class.w-lg-50]="isStandaloneForm">
  <h1 class="mb-4" tabindex="0">{{titleText}}</h1>
  <p-messages [value]="msgs" key="locationFormMsg" [closable]="true"></p-messages>
  <ness-verify-location (onAddressVerified)="onAddressVerified($event)" [locationToSearch]="searchLocation"></ness-verify-location>
  <ng-container *ngIf="selectedAddress$ | async as gunEvents">
    <div class="mb-3" *ngIf="gunEvents.length > 0">
      <ness-crime-gun-map #crimeGunMap [gunEvents]="gunEvents" [isPrimaryMap]="false" (pinMovedEvent)="mapPinMoved($event)"></ness-crime-gun-map>
      <button (click)="confirmAddress()" class="btn btn-active">Confirm Address</button>
    </div>
  </ng-container>
  <form class="mb-3" [formGroup]="locationInputForm">
    <fieldset>
      <legend class="h3 fw-normal">Location general information</legend>
      <div class="mb-3">
        <label class="form-label required-field" for="ConsolidatedAddressReturned">Consolidated address returned</label>
        <input id="ConsolidatedAddressReturned" type="text" formControlName="ConsolidatedAddressReturned" class="form-control" readonly aria-readonly="true" />
        <div class="invalid-feedback">
          <p *ngIf="locationInputForm.get('ConsolidatedAddressReturned').hasError('maxlength')">The consolidated address returned cannot exceed 80 characters.</p>
          <p *ngIf="locationInputForm.get('ConsolidatedAddressReturned').hasError('required')">The consolidated address field is required.</p>
        </div>
      </div>
      <div class="row g-3 mb-3">
        <div class="col-lg-6 col-12">
          <label class="form-label" for="CapturedLatitude">Captured latitude</label>
          <input id="CapturedLatitude" type="text" formControlName="CapturedLatitude" class="form-control" readonly aria-readonly="true" />
        </div>
        <div class="col-lg-6 col-12">
          <label class="form-label" for="CapturedLongitude">Captured longitude</label>
          <input id="CapturedLongitude" type="text" formControlName="CapturedLongitude" class="form-control" readonly aria-readonly="true" />
        </div>
      </div>
      <div class="mb-3" *ngIf="!isPersonAddressForm">
        <label class="form-label" for="LocationTypeID">Location type</label>
        <select id="LocationTypeID" class="form-select" formControlName="LocationTypeID">
          <option value="">Select location type</option>
          <ng-container *ngIf="locationService.locationTypes$ | async as locationTypes">
            <option *ngFor="let locType of locationTypes" value="{{locType.LocationTypeID}}">{{locType.LocationType}}</option>
          </ng-container>
        </select>
      </div>
      <div class="mb-3">
        <label for="StreetAddress" class="form-label required-field">Street address </label>
        <input id="StreetAddress" type="text" formControlName="StreetAddress" class="form-control" aria-required="true" (focusout)="stripWhiteSpace('StreetAddress')" required />
        <div class="invalid-feedback">
          <p *ngIf="locationInputForm.get('StreetAddress').hasError('maxlength')">The street address cannot exceed 80 characters.</p>
          <p *ngIf="locationInputForm.get('StreetAddress').hasError('required')">Please enter a street address.</p>
        </div>
      </div>
      <div class="row g-3 mb-3">
        <div class="col-lg-auto col-12">
          <label class="form-label" for="Unit">Unit</label>
          <input id="Unit" type="text" formControlName="Unit" class="form-control" />
        </div>
        <div class="col-lg col-12">
          <label for="CityName" class="form-label required-field">City</label>
          <input id="CityName" type="text" formControlName="CityName" class="form-control" required aria-required="true" (focusout)="stripWhiteSpace('CityName')" />
          <div class="invalid-feedback">
            Please enter a city.
          </div>
        </div>
      </div>
      <div class="mb-3">
        <label for="StateID" class="form-label required-field">State</label>
        <select class="form-control" id="StateID" formControlName="StateID" aria-required="true" required>
          <option value="">Select state</option>
          <ng-container *ngIf="lookupService.usStates$ | async as usStates">
            <option *ngFor="let state of usStates" [value]="state.StateID">{{state.StateName}}</option>
          </ng-container>
        </select>
        <div class="invalid-feedback">
          Please enter a state.
        </div>
      </div>
      <div class="row g-3 mb-3">
        <div class="col-lg-6 col-12">
          <label for="PostalCode" class="form-label required-field">Postal code <small>(Format: 99999)</small></label>
          <p-inputMask inputId="PostalCode" mask="99999" formControlName="PostalCode" styleClass="form-control" [required]="true" [ariaRequired]="true" [autoClear]="true" (onBlur)="onMaskBlur('PostalCode')"></p-inputMask>
          <div class="invalid-feedback">
            <p *ngIf="locationInputForm.get('PostalCode').hasError('pattern')">The postal code must contain 5 digits.</p>
            <p *ngIf="locationInputForm.get('PostalCode').hasError('required')">Please enter a postal code.</p>
          </div>
        </div>
        <div class="col-lg-6 col-12">
          <label class="form-label" for="PostalCodeExtended">Postal code extended <small>(Format: 9999)</small></label>
          <p-inputMask inputId="PostalCodeExtended" mask="9999" formControlName="PostalCodeExtended" styleClass="form-control" [ariaRequired]="true" [autoClear]="true" (onBlur)="onMaskBlur('PostalCodeExtended')"></p-inputMask>
          <div class="invalid-feedback">
            The postal code extended must contain 4 digits.
          </div>
        </div>
      </div>
      <div class="row g-3 mb-3">
        <div class="col-lg-6 col-12">
          <label class="form-label" for="EnteredLatitude">Latitude</label>
          <input id="EnteredLatitude" type="text" formControlName="EnteredLatitude" class="form-control" />
          <div class="invalid-feedback">
            <p *ngIf="locationInputForm.get('EnteredLatitude').hasError('required')">Please enter latitude.</p>
            <p *ngIf="locationInputForm.get('EnteredLatitude').hasError('maxlength')">Latitude can not exceed 80 characters.</p>
            <p *ngIf="locationInputForm.get('EnteredLatitude').hasError('longLatValid')">Invalid latitude pattern</p>
          </div>
        </div>
        <div class="col-lg-6 col-12">
          <label class="form-label" for="EnteredLongitude">Longitude</label>
          <input id="EnteredLongitude" type="text" formControlName="EnteredLongitude" class="form-control" />
          <div class="invalid-feedback">
            <ng-container *ngIf="locationInputForm.get('EnteredLongitude').hasError('required')">Please enter longitude.</ng-container>
            <ng-container *ngIf="locationInputForm.get('EnteredLongitude').hasError('maxlength')">Longitude can not exceed 80 characters.</ng-container>
            <ng-container *ngIf="locationInputForm.get('EnteredLongitude').hasError('longLatValid')">Invalid longitude pattern</ng-container>
          </div>
        </div>
      </div>
      <div class="mb-3">
        <label class="form-label" for="PoliceDepartment">Police department</label>
        <input id="PoliceDepartment" type="text" formControlName="PoliceDepartment" class="form-control" />
        <div class="invalid-feedback">
          The police department can not exceed 80 characters.
        </div>
      </div>
      <div class="row g-3 mb-3">
        <div class="col-lg-6 col-12">
          <label class="form-label" for="PoliceDepartmentSubArea1">Police department sub area 1 (district)</label>
          <input id="PoliceDepartmentSubArea1" type="text" formControlName="PoliceDepartmentSubArea1" class="form-control" />
          <div class="invalid-feedback" *ngIf="locationInputForm.get('PoliceDepartmentSubArea1').hasError('maxlength')">
            The police department sub area 1 can not exceed 80 characters.
          </div>
        </div>
        <div class="col-lg-6 col-12">
          <label class="form-label" for="PoliceDepartmentSubArea2">Police department sub area 2 (zone)</label>
          <input id="PoliceDepartmentSubArea2" type="text" formControlName="PoliceDepartmentSubArea2" class="form-control" />
          <div class="invalid-feedback">
            The police department sub area 2 can not exceed 80 characters.
          </div>
        </div>
      </div>
      <div class="mb-3">
        <label class="form-label" for="AnalystNotes">Notes</label>
        <textarea [rows]="textAreaRows" id="AnalystNotes" class="form-control" formControlName="AnalystNotes"></textarea>
        <div class="invalid-feedback">
          Notes can not exceed 2000 characters.
        </div>
      </div>
      <div>
        <button *ngIf="!isEventLocationForm && isEditForm" [disabled]="locationInputForm.invalid" class="btn btn-active mb-3" type="button" (click)="onOpenConfirmation()">Save location</button>
        <button *ngIf="!isEventLocationForm && !isEditForm" [disabled]="locationInputForm.invalid" class="btn btn-active mb-3" type="button" (click)="onSaveLocation()">Save location</button>
        <button *ngIf="isEventLocationForm && isEditForm" [disabled]="locationInputForm.invalid" class="btn btn-active mb-3" type="button" (click)="onOpenConfirmation()">{{ associationButtonLabel }}</button>
        <button *ngIf="isEventLocationForm && !isEditForm" [disabled]="locationInputForm.invalid" class="btn btn-active mb-3" type="button" (click)="onAssociateLocation()">{{ associationButtonLabel }}</button>
        <button type="button" *ngIf="((isEventLocationForm || isEditForm) && !isPersonAddressForm) || isPersonAddressForm" (click)="onClose()" class="btn btn-active mb-3">Close</button>
      </div>
    </fieldset>
  </form>
</section>
<div *ngIf="showConfirmEdit">
  <p-dialog [(visible)]="showConfirmEdit" [breakpoints]="{'992px': '75vw', '576px': '90vw'}" [style]="{ width: '50vw' }" [draggable]="false" [modal]="true" [resizable]="true" [baseZIndex]="10000" styleClass="disclaimerDialog" appendTo="body">
    <p-header>
      <i aria-hidden="true" class="p-1 me-1 fas fa-exclamation-triangle fa-1x"></i>
      Data Change Warning
    </p-header>
    <div>
      <span>
        All NESS data related to this location will reflect these changes.  Do you wish to continue?
      </span><br /><br />
    </div>
    <div>
      <button *ngIf="!isEventLocationForm" type="button" class="btn btn-active" (click)="onSaveLocation()" value="Submit">Save</button>
      <button *ngIf="isEventLocationForm" type="button" class="btn btn-active" (click)="onAssociateLocation()" value="Submit">{{ associationButtonLabel }}</button>
      <button type="button" class="btn btn-secondary" (click)="onCloseConfirmation()" value="Cancel">Cancel</button>
    </div>
  </p-dialog>
</div>
